export type Breakpoint = 'fontSize' | 'grid' | 'wide';

const breakpoint: { [key in Breakpoint]: string } = {
  fontSize: '28rem',
  grid: '64rem',
  wide: '78rem',
};

export default breakpoint;
